module.exports = __webpack_public_path__ + "static/media/mars-2.f6a9703a.jpg";